import { ImageSourcePropType } from 'react-native';
import {
  QualidadeVidaTrabalho,
  TipoRespostaQualidadeVidaTrabalho
} from './types';

const imagemExcelente = require('../images/humor-excelente.png');
const imagemMuitoBem = require('../images/humor-muito-bem.png');
const imagemBem = require('../images/humor-bem.png');
const imagemNaoEstouBem = require('../images/humor-nao-estou-bem.png');
const imagemMal = require('../images/humor-mal.png');

export interface RespostaQualidadeVidaTrabalho {
  tipo: TipoRespostaQualidadeVidaTrabalho;
  sufixoId: string;
  texto: string;
  descricao: string;
  cor: string;
  imagem: ImageSourcePropType;
}

export const montarRespostas = (
  dados: QualidadeVidaTrabalho
): RespostaQualidadeVidaTrabalho[] => [
  {
    tipo: TipoRespostaQualidadeVidaTrabalho.Excelente,
    sufixoId: 'excelente',
    texto: dados.respostaExcelente,
    descricao: dados.respostaExcelenteDescricao,
    cor: '#75d83c',
    imagem: imagemExcelente
  },
  {
    tipo: TipoRespostaQualidadeVidaTrabalho.MuitoBem,
    sufixoId: 'muito-bem',
    texto: dados.respostaMuitoBem,
    descricao: dados.respostaMuitoBemDescricao,
    cor: '#adda15',
    imagem: imagemMuitoBem
  },
  {
    tipo: TipoRespostaQualidadeVidaTrabalho.Bem,
    sufixoId: 'bem',
    texto: dados.respostaBem,
    descricao: dados.respostaBemDescricao,
    cor: '#c2abf3',
    imagem: imagemBem
  },
  {
    tipo: TipoRespostaQualidadeVidaTrabalho.NaoEstouBem,
    sufixoId: 'nao-estou-bem',
    texto: dados.respostaNaoEstouBem,
    descricao: dados.respostaNaoEstouBemDescricao,
    cor: '#ffa003',
    imagem: imagemNaoEstouBem
  },
  {
    tipo: TipoRespostaQualidadeVidaTrabalho.Mal,
    sufixoId: 'mal',
    texto: dados.respostaMal,
    descricao: dados.respostaMalDescricao,
    cor: '#f87d87',
    imagem: imagemMal
  }
];

export const TEMPO_DESFAZER = 10 * 1000;

// A barra do desfazer é montada em dois lugares (dentro do aviso de sucesso e na
// tela), e a tela recebe esses dados do card para montar a dela.
export interface DadosDesfazerRespostaQualidadeVidaTrabalho {
  resposta: RespostaQualidadeVidaTrabalho;
  fimPrazo: number;
  // Enquanto o prazo corre, vale o fimPrazo. Quando o Desfazer é acionado, o
  // prazo para e passa a valer o que restava dele, para a barra ficar parada
  // no mesmo ponto mesmo sendo remontada.
  restanteCongelado: number | null;
}
